import { List, ResourceSectionCard } from '@all-manager/design-system-v2';
import { useGetOpenTasks } from '../../api/useGetOpenTasks';
import OpenTaskItem from './OpenTaskItem';

export default function OpenTasksSection() {
  const { data: tasks, isLoading } = useGetOpenTasks();

  const items = tasks ?? [];

  return (
    <ResourceSectionCard
      variant="task"
      title="Tâches ouvertes"
      count={items.length}
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel="Aucune tâche ouverte"
    >
      <List disablePadding>
        {items.map((task) => (
          <OpenTaskItem key={task.id} task={task} />
        ))}
      </List>
    </ResourceSectionCard>
  );
}
